import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import checkTokenValidity from '../utils/tokenVerification';
import Spinner from '../components/spinner';

const PublicRoute = ({ element: Component, ...rest }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const verifyToken = async () => {
      const isValid = await checkTokenValidity();
      setIsAuthenticated(isValid);
    };
    verifyToken();
  }, []);

  if (isAuthenticated === null) {
    return (
      <div className="flex h-screen justify-center items-center">
        <Spinner message="Loading..." />
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Component {...rest} />;
};

export default PublicRoute;